import { useState } from 'react';

export const NumberAbbreviation = ({
  value,
  prefix = '$',
  maximumFractionDigits = 2,
}: {
  value: number;
  prefix?: string;
  maximumFractionDigits?: number;
}) => {
  const [intl] = useState(() =>
    Intl.NumberFormat('en-US', {
      notation: 'compact',
      minimumFractionDigits: 0,
      maximumFractionDigits,
    })
  );

  return (
    <>
      {prefix}
      {intl.format(value)}
    </>
  );
};
